import { getUtility } from '@livable/saas-react-components';
import { Box, Container, Typography, Grid } from '@mui/material';
import React from 'react';
import useStyles from '../styles';
const utilityIconExample = "\nimport { getUtility } from '@livable/saas-react-components';\n\nconst utility = getUtility('Name of the utility with upper case first letter');\n\nutilities:\n\u2014 Cable\n\u2014 Television\n\u2014 Gas-heat\n\u2014 District heat\n\u2014 Natural gas\n\u2014 Propane\n\u2014 Steam\n\u2014 Fuel oil\n\u2014 Electric\n\u2014 Electricity\n\u2014 Lighting\n\u2014 Irrigation\n\u2014 Landscaping\n\u2014 Chilled water\n\u2014 Water\n\u2014 Landline phone\n\u2014 Phone\n\u2014 Electricity-com\n\u2014 Hot-water\n\u2014 Internet\n\u2014 Telecom\n\u2014 Pest\n\u2014 Sanitation\n\u2014 Satelite\n\u2014 Sewer\n\u2014 Solar\n\u2014 Trash\n\u2014 Other\n";
export default function LvUtilitiesIcons() {
  const classes = useStyles();
  const listOfAllUtilities = ['Cable', 'Television', 'Gas-heat', 'District heat', 'Natural gas', 'Propane', 'Steam', 'Fuel oil', 'Electric', 'Electricity', 'Lighting', 'Irrigation', 'Landscaping', 'Chilled water', 'Water', 'Landline phone', 'Phone', 'Electricity-com', 'Hot-water', 'Internet', 'Telecom', 'Pest', 'Sanitation', 'Satelite', 'Sewer', 'Solar', 'Trash', 'Other'];
  const states = ['success', 'success-bold', 'info', 'warning', 'error'];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: classes.section
  }, "Utilities icons"), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, utilityIconExample), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 24,
    rowSpacing: 40
  }, listOfAllUtilities.map(utilityLabel => /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    key: utilityLabel
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    gutterBottom: true,
    variant: "h2"
  }, utilityLabel), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, getUtility(utilityLabel).title, " \u2014 utility.title"), /*#__PURE__*/React.createElement("div", {
    className: classes.utilityIcons
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.utilityIcon, " ").concat(classes.utilityIconPlain)
  }, getUtility(utilityLabel).icon(), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "utility.icon")), /*#__PURE__*/React.createElement("div", {
    className: classes.utilityIcon
  }, getUtility(utilityLabel).icon({
    svgType: 'static'
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "utility.icon", '({', " svgType: 'static' ", '}')), states.map(state => /*#__PURE__*/React.createElement("div", {
    className: classes.utilityIcon,
    key: state
  }, getUtility(utilityLabel).icon({
    color: state,
    svgType: 'static'
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "utility.icon", '({', " color: state, svgType: 'static' ", '})'))), /*#__PURE__*/React.createElement("div", {
    className: classes.utilityIcon
  }, getUtility(utilityLabel).tooltip(), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "utility.tooltip()")), states.map(state => /*#__PURE__*/React.createElement("div", {
    className: classes.utilityIcon,
    key: state
  }, getUtility(utilityLabel).tooltip(state), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "utility.tooltip(state)"))))))))));
}